<template>
  <iframe
    ref="iframeElement"
    :src="sharedAppUrl"
    class="hidden"
    @load="onLoadIframe"
  ></iframe>
</template>

<script setup>
import { useAppStore } from '~~/stores/app'

const {
  public: { sharedAppUrl },
} = useRuntimeConfig()

const appStore = useAppStore()

const iframeElement = ref(null)
const { sendLoadDataMessage } = useIframeSharedData(iframeElement)

const onLoadIframe = () => {
  const loadDataInterval = setInterval(() => {
    if (!appStore.isReturnedSharedInitData) {
      sendLoadDataMessage()
    } else {
      clearInterval(loadDataInterval)
    }
  }, 500)
}
</script>
